<div class="april-madness-faq-modal tw-relative tw-h-[54rem] tw-max-h-[73dvh] tw-rounded-xl tw-bg-gray-650 tw-px-6 tw-py-8">
  <app-ui-button
    class="gray-color ghost tw-absolute -tw-top-12 tw-right-0 tw-z-2 tw-hidden !tw-size-[2rem] min-[501px]:tw-block lp:-tw-right-14 lp:-tw-top-2"
    [style.--button__color]="'#B4C5CD'"
    [style.--button__color_hover]="'#B4C5CD'"
    [style.--button__color_focus]="'#B4C5CD'"
    [style.--button__color_active]="'#B4C5CD'"
    [style.--button__padding-x]="'0.25rem'"
    (buttonClick)="onClose()"
  >
    <mat-icon
      svgIcon="close"
      class="!tw-size-[2rem]"
    />
  </app-ui-button>
  <div class="custom-scroll tw-flex tw-h-full tw-flex-col tw-gap-[1.62rem] tw-overflow-y-auto">
    <div
      class="april-madness-faq-content"
      [innerHTML]="sanitize('EVENT.ICE_BREAKERS_EVENT.FAQ_TEXT' | translate)"
    ></div>
    <app-event-button
      [size]="'full'"
      class="tw-mx-auto tw-mt-auto tw-w-[12rem] tw-py-1"
      (buttonClick)="onClose()"
      >{{ 'EVENT.ICE_BREAKERS_EVENT.OK' | translate }}</app-event-button
    >
  </div>
</div>
